<template>
    <v-select :value="localValue" @input="onSelectionChanged"
              :searchable="false" :multiple="false" :filterable="false"
              v-bind="{options, getOptionLabel, placeholder, disabled}">
        <slot/>
    </v-select>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop, Watch} from 'vue-property-decorator';
    import vSelect from 'vue-select';

    // This component exists to wrap vue-select which at the time of writing has a bug in it that this wrapper fixes
    // The wrapper implements a version of a vue-select component with single select and searching disabled.

    @Component({
        components: {
            vSelect
        }
    })
    export default class SimpleSelect extends Vue {
        @Prop()
        options;
        @Prop()
        value;
        @Prop({type: Function})
        getOptionLabel;
        @Prop({type: String})
        placeholder;
        @Prop({type: Boolean})
        disabled;

        localValue = null;

        @Watch('value')
        onValueChanged() {
            this.localValue = this.value;
        }

        mounted() {
            this.localValue = this.value;
        }

        onSelectionChanged(newSelection) {
            // Workaround: vSelect allows you to deselect the selected item in single-mode.
            // A patch for this exists but has not yet been released.
            if (newSelection) {
                this.localValue = newSelection;
                this.$emit('input', newSelection);
            } else {
                // Clear the value now and on the next tick set it back, forcing binding updates.
                const resetValue = this.localValue;
                this.localValue = null;
                this.$nextTick(() => {
                    this.localValue = resetValue;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/SingleSelect.vue